// extracted by mini-css-extract-plugin
export var videoPlayer = "VimeoPlayer-module--videoPlayer--15814";
export var wrapper = "VimeoPlayer-module--wrapper--a484d";